import React from 'react';
import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { onboardingButton as orgConfig } from 'org/configs/modules.config';

import externalWhiteSVG from 'core/assets/images/icons/external_white.svg';

const defaultConfig = {
  defaults: {
    viewData: {
      getButtonHeader: () => ('button'),
      getButtonDescription: () => '',
      rewardsType: () => ('miles'),
      getButtonLaterText: () => 'I\'ll get the button later',
      secondBulletText: 'Automatically apply coupons at checkout',
      customThirdBulletText: 'Find new stores and get the lowest price',
      starsSvg: undefined,
      chromeText: undefined,
      mobileButtonHeader: '',
      mobileButtonDescription:
        'With the mobile button easily activate miles and apply ' +
        'coupons while shopping on your phone. Available for iOS 15+.',
      mobileButtonImg: externalWhiteSVG,
      mobileButtonCTA: 'Download for iOS',
      mobileButtonLaterText: 'No thanks',
      getAddButtonText: (isMobileMQ) => (isMobileMQ ? <>Add to desktop</> : <>Get the button</>),
    },
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
